export default __webpack_public_path__ + "static/media/pc-image-8.3f28d2c6.webp";